// <script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"> </script>
! function(a, b, c) {
  function d(a) {
    console.log(a, '111')
    var c = "default";
    a.self_redirect === !0 ? c = "true" : a.self_redirect === !1 && (c = "false");
    var d = b.createElement("iframe"),
      e = "https://open.weixin.qq.com/connect/qrconnect?appid=" + a.appid + "&scope=" + a.scope + "&redirect_uri=" + a
      .redirect_uri + "&state=" + a.state + "&login_type=jssdk&self_redirect=" + c + '&styletype=' + (a.styletype ||
        '') + '&sizetype=' + (a.sizetype || '') + '&bgcolor=' + (a.bgcolor || '') + '&rst=' + (a.rst || '') +
      "&stylelite=0&fast_login=0";
    e += a.style ? "&style=" + a.style : "",
      e += a.href ? "&href=" + a.href : "",
      d.src = e,
      d.frameBorder = "0",
      d.allowTransparency = "true",
      d.sandbox = "allow-scripts allow-top-navigation allow-same-origin", //重点
      d.scrolling = "no",
      d.width = "300px",
      d.height = "400px";
    var f = b.getElementById(a.id);
    f.innerHTML = "",
      f.appendChild(d)
  }
  a.WxLogin = d
}(window, document);



// WEBPACK FOOTER //
// ./src/assets/js/wxLogin.js